import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  width: 100%;
  background: ${({ theme }) => theme.bg};
  padding: 25px 0;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const Copy = styled.div`
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Wrapper>
        <Copy>© {new Date().getFullYear()} Ahmed Tarek. All rights reserved.</Copy>
      </Wrapper>
    </FooterContainer>
  );
};

export default Footer;
